import { render, staticRenderFns } from "./UserResetPassword.vue?vue&type=template&id=4ecf3c26&"
import script from "./UserResetPassword.vue?vue&type=script&lang=js&"
export * from "./UserResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecf3c26')) {
      api.createRecord('4ecf3c26', component.options)
    } else {
      api.reload('4ecf3c26', component.options)
    }
    module.hot.accept("./UserResetPassword.vue?vue&type=template&id=4ecf3c26&", function () {
      api.rerender('4ecf3c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserResetPassword.vue"
export default component.exports